import React, { useState, useEffect } from 'react';
import './news.scss';
import Header from '../components/headerBar';
import Footer from '../components/footer';
import { Pagination } from 'antd';
import { listNews } from '../api/news';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import NO_CONTENT from '../assets/no_content.png';

interface IRecommendNewsInfo {
  id: number;
  publishDate: string;
  status: number;
  title: string;
  type: 1 | 2 | 3;
}

interface IQueryParamsProps {
  page: number;
  limit: number;
  type: 1 | 2 | 3 | null;
}

const map = Object.freeze({
  a: {
    en: 'ALL',
    'zh-cn': '全部资讯',
  },
  b: {
    en: 'HOT',
    'zh-cn': '热门活动',
  },
  c: {
    en: 'NEWS',
    'zh-cn': '公司动态',
  },
  d: {
    en: 'FOCUS',
    'zh-cn': '行业焦点',
  },
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const News = () => {
  const [newsList, setNewsList] = useState([]);
  const [total, setTotal] = useState(0);
  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');

  const history = useHistory();

  const location = useLocation();

  const query = useQuery();
  const { lang } = useParams();

  const toNewsDetail = (id: number) => history.push(`/${lang}/news/${id}`);

  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  const type = Object.freeze({
    1: {
      en: 'HOT',
      'zh-cn': '热门活动',
    },
    2: {
      en: 'NEWS',
      'zh-cn': '公司动态',
    },
    3: {
      en: 'FOCUS',
      'zh-cn': '行业焦点',
    },
  });

  const color = Object.freeze({
    1: 'red',
    2: 'brown',
    3: 'blue',
  });

  const [queryParams, setQueryParams] = useState<IQueryParamsProps>({
    page: 1,
    limit: 10,
    type: null,
  });

  const changePage = (page: number) => {
    setQueryParams({
      ...queryParams,
      page,
    });
  };

  const changeType = (type: 1 | 2 | 3 | null) =>
    setQueryParams({
      ...queryParams,
      type,
    });

  useEffect(() => {
    listNews(queryParams).then((res) => {
      if (res.status === 200) {
        setNewsList(res.data);
        setTotal(res.total);
      }
    });
  }, [queryParams]);

  useEffect(() => {
    const type = query.get('type');

    if (type)
      setQueryParams({
        ...queryParams,
        // @ts-ignore
        type: Number(type),
      });
  }, [location.search]);

  return (
    <div className='news'>
      <Header />
      <div className='news-container'>
        <div className='new-type-container'>
          <div className={`new-type ${queryParams.type ? '' : 'active'}`} onClick={() => changeType(null)}>
            【{map.a[la]}】
          </div>
          <div className={`new-type ${queryParams.type === 1 ? 'active' : ''}`} onClick={() => changeType(1)}>
            【{map.b[la]}】
          </div>
          <div className={`new-type ${queryParams.type === 2 ? 'active' : ''}`} onClick={() => changeType(2)}>
            【{map.c[la]}】
          </div>
          <div className={`new-type ${queryParams.type === 3 ? 'active' : ''}`} onClick={() => changeType(3)}>
            【{map.d[la]}】
          </div>
        </div>
        <div className='new-content-container'>
          {newsList.length > 0 ? (
            newsList.map((news: IRecommendNewsInfo) => (
              <div className='news-list' key={news.id} onClick={() => toNewsDetail(news.id)}>
                <div className={`news-type-name ${color[news.type]}`}>【{type[news.type][la]}】</div>
                <div className='news-title'>{news.title}</div>
                <div className='news-ctime'>{news.publishDate}</div>
              </div>
            ))
          ) : (
            <img src={NO_CONTENT} className='no-content' />
          )}
        </div>
      </div>
      <div className='news-pagation-container'>
        <Pagination
          hideOnSinglePage
          onChange={changePage}
          size='small'
          pageSize={10}
          showSizeChanger={false}
          total={total}
        />
      </div>
      <Footer />
    </div>
  );
};

export default News;
